// extracted by mini-css-extract-plugin
module.exports = {"icon":"unsaved_icon__XtnoJ","description":"unsaved_description__swwye"};